module.exports = __webpack_public_path__ + "53f5cbfadc48e1026205b2d7f4fe93fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/realisations/saladexpress/saladexpress_06.jpg
// module id = 0yB7
// module chunks = 0